import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    downtimeSummaryWrapper: {
        padding: "24px 42px 24px 42px",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
    },
    card: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        height: "100%",
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        padding: 24,
        boxSizing: "border-box",
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 20,
        borderBottom: `1px solid ${theme.palette.border.main}`,
        paddingBottom: 12,
    },
    cardTitle: {
        fontFamily: "Source Sans 3",
        fontSize: 18,
        fontWeight: 400,
    },
    closeIcon: {
        cursor: "pointer",
        color: theme.palette.primary.dark,
    },
}));
